import React, {useEffect, useContext} from 'react'
import {Form, InputNumber} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";
import {PurchaseContext} from "../../../context/PurchaseContext";


const TaxInput = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {taxes} = useContext(PurchaseContext)
    const [taxList, setTaxList] = taxes

    useEffect(() => {
        form.setFieldsValue({taxRatio: record.taxRatio})
    }, [record])

    const handleTaxChange = ({target: {value}}) => {
        const newList = replaceIndexAt(
            taxList,
            {
                ...taxList[rowIndex],
                taxRatio: value
            },
            rowIndex
        )
        setTaxList(newList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={'taxRatio'}>
                    <InputNumber onBlur={handleTaxChange} step={0.1}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default TaxInput